import React, { FC } from "react";
import styles from "./products-slider-skin-1.module.css";
import {
  Product,
  makeUrl,
  AppLink,
  ProductCarouselConfig,
  TypeOptionConfig,
  ITheme,
  categoryNormalize,
  LocalWidgetConfig,
  StoreMetadata,
  TemplateType } from
"@commons-monorepo/index";
import { useTranslation } from "react-i18next";
import { UiButton } from "@ui-monorepo/index";
import { ProductCard3 } from "../../../";
import { useLocation } from "react-router-dom";
import { CallerEnum } from "../../../product-card/product-card.types";
import WidgetContainer from "../../../widget-container";
import Slider from "react-slick";
import { SliderArrowProps } from "../../../testimonials/testimonials.types";

const ProductsSliderSkin1: FC<{
  id: string;
  products: Product[];
  config: ProductCarouselConfig;
  log: () => void;
  theme: ITheme;
  localConfig: LocalWidgetConfig;
  storeMetadata: StoreMetadata;
}> = ({
  id,
  products: productList,
  config,
  log,
  theme,
  localConfig,
  storeMetadata
}) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const products = [...(productList || [])];

  const SliderArrow = ({ className, onClick }: SliderArrowProps) => {
    return (
      <UiButton
        appearance='icon'
        className={className || ""}
        leftIcon={<span className='icon-arrow-right' />}
        onClick={onClick}
        theme={theme} />);


  };

  const settings = {
    arrows: true,
    className: `${products.length >= 3 ? "productsSliderInfinite" : ""} ${
    products.length === 1 ? "productsSlideCenter" : ""
    }`,
    dots: false,
    infinite: products.length >= 3,
    initialSlide: 0,
    slidesToShow: 3,
    slidesToScroll: 3,
    speed: 500,
    variableWidth: false,
    prevArrow: <SliderArrow />,
    nextArrow: <SliderArrow />,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerPadding: "0.5rem",
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true
      }
    },
    {
      breakpoint: 425,
      settings: {
        arrows: false,
        centerPadding: "0.5rem",
        infinite: products.length >= 2,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true
      }
    }]

  };

  const highLightBackground = config?.highlight_background;

  const goTo = (): string => {
    switch (config.filter_type) {
      case TypeOptionConfig.category:
        return makeUrl(
          pathname,
          `categoria/${categoryNormalize(config?.category || "")}`
        );
      default:
        return makeUrl(pathname, `todos-los-productos`);
    }
  };

  return (
    <WidgetContainer
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}
      highlight={!!highLightBackground}>

      <article className={styles.productsSlider}>
        <header className={styles.header}>
          <h2 className={styles.title}>
            {config.filter_type === TypeOptionConfig.category ?
            `${config.category_name || config.category}` :
            config.display_name ? config.display_name : t("productsCarousel.title")}
          </h2>
          <AppLink onClick={log} to={goTo()}>
            <UiButton isSecondary className={styles.more} theme={theme}>
              {t("productsCarousel.button")}
            </UiButton>
          </AppLink>
        </header>
        <div className={styles.products}>
          <Slider {...settings}>
            {products?.map((product: Product, index: number) =>
            <div
              className={`${styles.slideItem} productsSlideItem`}
              key={`${id}-productsSliderSkin1-${
              product.id
              }-${index}-${Math.random()}`}>

                <ProductCard3
                product={product}
                withTags={false}
                theme={{
                  ...theme,
                  template: {
                    ...theme.template,
                    PRODUCT_CARD: TemplateType.PRODUCT_CARD_3
                  }
                }}
                cartProducts={localConfig.cart.cartProducts}
                addProduct={localConfig.cart.addProduct}
                manuallyChangeProduct={localConfig.cart.manuallyChangeProduct}
                removeProduct={localConfig.cart.removeProduct}
                locale={localConfig.locale}
                currency={localConfig.currency}
                storeMetadata={storeMetadata}
                caller={CallerEnum.ProductCarousel} />

              </div>
            )}
          </Slider>
        </div>
      </article>
    </WidgetContainer>);

};

export default ProductsSliderSkin1;